<script setup lang="ts">
defineProps<{
  active?: boolean;
}>();
</script>

<template>
  <template v-if="!active">
    <svg xmlns="http://www.w3.org/2000/svg" data-name="Livello 1" viewBox="0 0 50 50" fill="currentColor">
      <path
        d="M25 45.47c-14.95 0-22.19-4.41-24.05-5.75-.55-.38-.9-1.06-.9-1.79 0-1.31 1.07-2.37 2.38-2.37h45.12c1.31 0 2.38 1.06 2.38 2.37 0 .71-.33 1.37-.89 1.79-1.87 1.35-9.1 5.76-24.05 5.76ZM2.44 37.55c-.21 0-.38.16-.38.37 0 .07.02.14.05.16 1.76 1.28 8.54 5.39 22.89 5.39s21.13-4.11 22.87-5.37c.06-.05.07-.13.07-.17 0-.21-.17-.37-.38-.37H2.44Zm43.86-4.64H3.73c-.55 0-1-.45-1-1v-5.28c0-7.47 4.2-14.16 10.96-17.47.47-.23 1.04-.06 1.31.4l3.69 6.39V8.16c0-2.01 1.64-3.64 3.66-3.64h5.34c2.02 0 3.66 1.63 3.66 3.64v7.79l3.69-6.4a1 1 0 0 1 1.31-.4c6.69 3.27 10.89 9.89 10.96 17.27v5.48c0 .55-.45 1-1 1Zm-41.57-2H45.3v-4.47c-.06-6.3-3.49-11.99-9.01-15.05l-3.51 6.09a1.84 1.84 0 0 1-3.43-.91v-8.4c0-.9-.75-1.64-1.66-1.64h-5.34c-.92 0-1.66.74-1.66 1.64v8.4c0 1.01-.82 1.83-1.84 1.83-.67 0-1.28-.36-1.6-.93l-3.5-6.08c-5.58 3.1-9.01 8.86-9.01 15.25v4.28Zm26.31-14.43Zm-12.06 0Z"
      />
    </svg>
  </template>
  <template v-else>
    <svg xmlns="http://www.w3.org/2000/svg" id="Livello_1" data-name="Livello 1" viewBox="0 0 50 50" fill="currentColor">
      <path
        d="M3.66 32.75h42.71c.45 0 .82-.37.82-.82v-5.5c-.07-7.33-4.25-13.91-10.89-17.16a.814.814 0 0 0-1.07.33l-4.05 6.94V8.11c0-1.91-1.56-3.46-3.49-3.46h-5.36c-1.92 0-3.49 1.55-3.49 3.46l-.04 8.43-4-6.94a.83.83 0 0 0-1.07-.33c-6.72 3.3-10.89 9.95-10.89 17.37v5.3c0 .45.37.82.82.82ZM47.63 35.77H2.37a2.2 2.2 0 0 0-2.21 2.19c0 .68.31 1.29.83 1.65 1.85 1.35 9.07 5.74 24.02 5.74s22.16-4.39 24.02-5.74c.51-.38.82-.99.82-1.64a2.2 2.2 0 0 0-2.21-2.19Z"
      />
    </svg>
  </template>
</template>
